import { createContext, useContext, useState } from 'react';

export interface NextDep {
  time: string;
  destination?: string;
  updatedAt?: number;
  source?: 'live' | 'cache';
}

interface FerryDepartureContextValue {
  nextDep: NextDep | null;
  setNextDep: (dep: NextDep | null) => void;
}

const FerryDepartureContext =
  createContext<FerryDepartureContextValue>({
    nextDep: null,
    setNextDep: () => {},
  });

export const FerryDepartureProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [nextDep, setNextDep] =
    useState<NextDep | null>(null);
  return (
    <FerryDepartureContext.Provider
      value={{ nextDep, setNextDep }}
    >
      {children}
    </FerryDepartureContext.Provider>
  );
};

export const useFerryDeparture = () =>
  useContext(FerryDepartureContext);
